import React from 'react'
import AppPublishStatusView from '../AppPublishStatusView'
import statusSrc from './status.svg'

const AppPublished = () => (
  <AppPublishStatusView
    title="Published!"
    description="Your app is public and now out in the wild! Check it out in the Drift App Directory!"
    iconSrc={statusSrc}
  />
)

export default AppPublished
